var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApplicationRequirements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.03 304.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-appreq,.cls-2-appreq,.cls-3-appreq,.cls-4-appreq,.cls-5-appreq{fill:none;}.cls-1-appreq,.cls-6-appreq,.cls-7-appreq,.cls-8-appreq,.cls-9-appreq,.cls-1-appreq0{stroke-width:0px;}.cls-2-appreq{stroke:#d9c9b1;stroke-width:5px;}.cls-2-appreq,.cls-1-appreq1,.cls-3-appreq,.cls-4-appreq,.cls-5-appreq{stroke-miterlimit:10;}.cls-1-appreq1,.cls-4-appreq,.cls-5-appreq{stroke:#004f68;}.cls-1-appreq1,.cls-8-appreq{fill:#fff;}.cls-3-appreq{stroke:#009ed9;stroke-width:4px;}.cls-5-appreq{stroke-dasharray:0 0 0 8;stroke-linecap:round;stroke-width:2px;}.cls-6-appreq{fill:#c3d9d6;}.cls-7-appreq{fill:#d9c9b1;}.cls-9-appreq{fill:#e9e0d2;}.cls-1-appreq0{fill:#004f68;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-appreq",
    width: 438.03,
    height: 304.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-appreq1",
    x: 244,
    y: 69.68,
    width: 136.94,
    height: 183.14,
    transform: "translate(36.45 -56.59) rotate(10.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-appreq0",
    d: "m276.03,257.73c-1.98,1.9-3.64,4.1-4.95,6.52l-6.53,12.12,12.36-6.07c2.46-1.21,4.72-2.79,6.7-4.7l14.14-13.62-7.58-7.87-14.14,13.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-appreq0",
    d: "m358.72,193.26c2.17-2.09,2.24-5.55.15-7.72s-5.55-2.24-7.72-.15l-16.82,16.2,7.58,7.87,16.82-16.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6-appreq",
    x: 285.39,
    y: 221.32,
    width: 61.3,
    height: 10.92,
    transform: "translate(-68.91 282.67) rotate(-43.92)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4-appreq",
    points: "343.32 193.77 333.48 196.79 317.01 212.66"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2-appreq",
    cx: 315.21,
    cy: 139.29,
    r: 32.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-appreq1",
    d: "m361.85,110.91l-18.32,5.94-2.23-7.22,18.32-5.94c1.99-.61,4.11.5,4.72,2.5h0c.61,1.99-.5,4.11-2.5,4.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-appreq1",
    cx: 308.76,
    cy: 124.25,
    r: 37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7-appreq",
    cx: 308.76,
    cy: 124.25,
    r: 31.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8-appreq",
    cx: 289.38,
    cy: 110.15,
    r: 3.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8-appreq",
    cx: 297.19,
    cy: 103.8,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8-appreq",
    cx: 297.16,
    cy: 112.33,
    r: 2.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9-appreq",
    x: 67.33,
    y: 56.23,
    width: 167.67,
    height: 215.08,
    rx: 8.35,
    ry: 8.35,
    transform: "translate(-44.83 57.67) rotate(-18.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4-appreq",
    d: "m114.54,62.64l73.29-25.04c4.36-1.49,9.11.84,10.6,5.2l27.96,81.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8-appreq",
    x: 82.7,
    y: 72.2,
    width: 136.94,
    height: 183.14,
    transform: "translate(-44.83 57.67) rotate(-18.86)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4-appreq",
    points: "245.57 228.28 115.98 272.56 56.77 99.25"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4-appreq",
    x: 91.88,
    y: 120.89,
    width: 30.22,
    height: 30.22,
    transform: "translate(-38.22 41.9) rotate(-18.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4-appreq",
    x: 106.15,
    y: 162.64,
    width: 30.22,
    height: 30.22,
    transform: "translate(-50.95 48.75) rotate(-18.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4-appreq",
    x: 120.41,
    y: 204.38,
    width: 30.22,
    height: 30.22,
    transform: "translate(-63.68 55.6) rotate(-18.86)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4-appreq",
    x1: 136.48,
    y1: 117.95,
    x2: 180.98,
    y2: 102.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5-appreq",
    x1: 141.36,
    y1: 132.24,
    x2: 185.86,
    y2: 117.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4-appreq",
    x1: 150.74,
    y1: 159.69,
    x2: 195.24,
    y2: 144.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5-appreq",
    x1: 155.62,
    y1: 173.98,
    x2: 200.13,
    y2: 158.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4-appreq",
    x1: 165,
    y1: 201.43,
    x2: 209.5,
    y2: 186.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5-appreq",
    x1: 169.88,
    y1: 215.72,
    x2: 214.39,
    y2: 200.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-appreq0",
    d: "m168.83,60.97c-3.29-9.63-13.77-14.77-23.4-11.48l-6.56,2.24c-4,1.37-8.44.15-11.16-3.1-4.69-5.6-12.51-8.04-19.84-5.54s-12.02,9.22-12.3,16.52c-.16,4.23-2.93,7.91-6.93,9.28l-6.56,2.24c-9.63,3.29-14.77,13.77-11.48,23.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3-appreq",
    points: "95.56 130.86 109.7 138.88 125.81 99.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3-appreq",
    points: "109.36 175.56 123.49 183.58 139.6 143.95"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationRequirements);
export default __webpack_public_path__ + "static/media/application-requirements.1f2cfacdb7d5a6f78b5e962094537165.svg";
export { ForwardRef as ReactComponent };